import { call, put, takeLatest, delay } from "redux-saga/effects";
import axios from "axios";

import {
    LOAD_PERMISSIONS,
    SET_PERMISSIONS,
    PERMISSION_LOADING
} from "./types";

import { parsePermissions } from "../../utils/permissionParser";

function fetchUserPermissions(userId, token) {
    return axios.get(
        `https://api.kunalsdrumclass.com/api/GetUserPermissionByUserId?userId=${userId}`,
        {
            headers: { Authorization: `Bearer ${token}` }
        }
    );
}

function fetchRolePermissions(roleId, token) {
    return axios.get(
        `https://api.kunalsdrumclass.com/api/GetRolePermissionByRoleId?roleId=${roleId}`,
        {
            headers: { Authorization: `Bearer ${token}` }
        }
    );
}

function* loadPermissionsSaga() {
    try {
        while (true) {
            yield put({ type: PERMISSION_LOADING });

            const user = JSON.parse(localStorage.getItem("authUser"));
            const token = localStorage.getItem("authToken");

            let rows = [];

            if (user.Role === "Student") {
                const studentPermissions = [
                    { Id: 1, User_Id: user.Id, Module_Id: 1, Permission_Id: 2, IsActive: 1, IsDeleted: 0 },
                    { Id: 2, User_Id: user.Id, Module_Id: 11, Permission_Id: 2, IsActive: 1, IsDeleted: 0 },
                    { Id: 3, User_Id: user.Id, Module_Id: 12, Permission_Id: 2, IsActive: 1, IsDeleted: 0 },
                ];

                yield put({
                    type: SET_PERMISSIONS,
                    payload: parsePermissions(studentPermissions)
                });
                return;
            }

            try {
                const userRes = yield call(
                    fetchUserPermissions,
                    user.Id,
                    token
                );

                rows = userRes.data?.recordsets?.[0] || [];

            } catch (error) {

                if (error.response?.status !== 404) {
                    throw error; // real error
                }
            }

            if (!rows.length) {
                const roleRes = yield call(
                    fetchRolePermissions,
                    user.RoleId,
                    token
                );

                rows = roleRes.data?.recordsets?.[0] || [];
            }

            const parsed = parsePermissions(rows);

            yield put({
                type: SET_PERMISSIONS,
                payload: parsed
            });

            yield delay(5000);
        }
    } catch (error) {
        console.error("Permission error:", error);
    }
}

export default function* permissionSaga() {
    yield takeLatest(LOAD_PERMISSIONS, loadPermissionsSaga);
}